module.exports = __webpack_public_path__ + "img/arrow-right-long.8a6b4ea5.svg";